import React from "react";
import point from "./../../../Images/point.png";

const SheaButterHairSpaWho = () => {
  return (
    <div className="hairSalonInSahakaraWhy">
      <h5>Who Can Benefit from Shea Butter Hair Spa?</h5>
      <p>
        Whether you have dry, damaged, frizzy, or lifeless hair, our{" "}
        <a href="https://scentlifestyle.com/shea-butter-hair-spa-in-bangalore">
          Shea Butter Hair Spa in Bangalore
        </a>{" "}
        is perfect for you. It’s also an excellent choice for:
      </p>
      <ul>
        <li>
          <span>
            <img src={point} alt="point" /> Those dealing with hair breakage and
            split ends.{" "}
          </span>
        </li>{" "}
        <li>
          <span>
            <img src={point} alt="point" /> Individuals with color-treated or
            chemically processed hair{" "}
          </span>
        </li>
        <li>
          <span>
            <img src={point} alt="point" /> People experiencing scalp dryness or
            irritation.{" "}
          </span>
        </li>
        <li>
          <span>
            <img src={point} alt="point" /> Anyone looking to pamper themselves
            with a luxurious hair care treatment.{" "}
          </span>
        </li>{" "}
      </ul>
    </div>
  );
};

export default SheaButterHairSpaWho;
